/**
* 4G 订阅规则
*/
<template>
	<div class="bg-gray-50">
		<div>
			<div class="bg-white rounded-lg shadow-sm p-8">
				<div class="flex items-center justify-between mb-6 pb-4 border-b border-gray-100">
					<h1 class="text-2xl font-bold text-gray-800">
						<!-- 4G 设备订阅规则 -->
						{{ $t('language000397') }}
					</h1>
				</div>

				<div class="space-y-6">
					<div class="bg-blue-50 p-4 rounded-lg">
						<h2 class="text-lg font-semibold text-gray-800 mb-3">
							<!-- 基础配置步骤 -->
							{{ $t('language000398') }}
						</h2>
						<ol class="list-decimal list-inside space-y-3 text-gray-600">
							<li>
								<!-- 拿到设备后，在蓝牙模式下调用获取设备 token 接口 -->
								{{ $t('language000399') }}
							</li>
							<li>
								<!-- 设备回复 token 后，调用蓝牙命令解密接口完成设备 token 存储 -->
								{{ $t('language000400') }}
							</li>
							<li>
								<!-- 调用设置设备服务器地址、ip、端口的接口，此接口不需要平台方提供服务器等信息 -->
								{{ $t('language000401') }}
							</li>
							<li>
								<!-- 在平台左侧导航栏开启 4G 相关功能，用于接收 4G 设备指令回复结果 -->
								{{ $t('language000402') }}
							</li>
						</ol>
					</div>

					<div class="bg-yellow-50 p-4 rounded-lg">
						<h2 class="text-lg font-semibold text-gray-800 mb-3">
							<!-- 重要提示 -->
							{{ $t('language000403') }}
						</h2>
						<p class="text-gray-600 leading-relaxed">
							<!-- 在代码中连接消息服务器时，需要保证 client_id 的唯一性。如果多个订阅端使用同一个 client_id，将导致无法连接消息服务器。建议在连接时给 client_id
							后面追加一个 10~15 个字符的随机字符串，以确保唯一性。 -->
							{{ $t('language000404') }}
						</p>
					</div>

					<div class="bg-gray-50 p-4 rounded-lg">
						<h2 class="text-lg font-semibold text-gray-800 mb-3">
							<!-- 负载均衡配置 -->
							{{ $t('language000405') }}
						</h2>
						<div class="space-y-3">
							<p class="text-gray-600">
								<!-- 若平台方存在 2 台以上的服务器集群，使用 4G 订阅功能时，需要确保消息的负载均衡。配置方式如下： -->
								{{ $t('language000406') }}
							</p>
							<div class="bg-gray-100 p-3 rounded font-mono text-sm">
								<p class="mb-2">
									<!-- 原主题格式： -->
									{{ $t('language000407') }}
								</p>
								<code class="text-blue-600">device/client_abc1234sdfabc4980233333</code>
								<p class="mt-2 mb-2">
									<!-- 负载均衡主题格式： -->
									{{ $t('language000408') }}
								</p>
								<code
									class="text-green-600">$share/$queue/device/client_abc1234sdfabc498023333333</code>
							</div>
							<div class="mt-4">
								<h3 class="font-semibold mb-2">
									<!-- 示例说明： -->
									{{ $t('language000409') }}
									</h3>
								<p class="text-gray-600">
									<!-- 当服务器向该主题发送"Hello World"消息时，如果有两个订阅端 s1、s2，那么只有其中一个订阅端会收到该消息，实现负载均衡。 -->
									{{ $t('language000410') }}
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>


		<img v-if="isChinese" :src="require('../../../../assets/gen3_zh.png')" />
		<img v-else :src="require('../../../../assets/gen3_ch.png')" />


	</div>
</template>

<script>
	export default {
		mounted() {
			if ((this.$i18n.locale === 'zh' || this.$i18n.locale === 'zh-CN' || this.$i18n.locale === 'zh-TW')) {
				this.isChinese = true;
				console.log("返回的值：", "true")
			} else {
				this.isChinese = false;
				console.log("返回的值：", "false")
			}
		},
		data() {
			return {
				isChinese: false,
			};
		},
		methods: {}
	};
</script>

<style scoped>
	.font-mono {
		font-family: 'Courier New', Courier, monospace;
	}
</style>